import React from 'react';
import { Animate } from 'react-move';
import { renderChildren } from '@fiverr-private/ui_utils';
import { FadeOverrideProps, TransitionProps } from '../../types';
import variants from './variants';

const Fade = ({
  delay,
  duration = 'fast2',
  easing = 'linear',
  unmountOnExit,
  in: isOpen = true,
  endingOpacity,
  children,
}: TransitionProps & FadeOverrideProps) => {
  const custom = { delay, duration, easing, endingOpacity };

  return (
    <Animate
      show={unmountOnExit ? isOpen : true}
      start={variants.exit(custom)}
      enter={() => (isOpen ? variants.enter(custom) : variants.exit(custom))}
      update={() => (isOpen ? variants.enter(custom) : variants.exit(custom))}
      leave={variants.exit(custom)}
    >
      {(animationState) =>
        renderChildren(children, {
          style: {
            ...(children.props.style || {}),
            display: animationState.opacity === 0 ? 'none' : undefined,
            visibility: animationState.opacity === 0 ? 'hidden' : 'visible',
            ...animationState,
          },
        })
      }
    </Animate>
  );
};

Fade.displayName = 'Fade';

export default Fade;
